<template>
    <div class="contact">
        <div class="title">
            评估详情
        </div>
        <div class="form-list" v-for="item in questionList">
            <div class="form-title">{{ item.title }}:</div>
            <div class="question-lists">
                <div class="question-list" v-for="question in item.children">
                    <div class="question-title">{{ question.name }}:</div>
                    <div>
                        <p class="input-p" v-for="item in getActive(question.active)">
                            {{ item }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            totalScore: 0,
            stepActive: 2,
            questionList: [],
            id: '',
            loading: false,
        };
    },
    computed: {
    },
    mounted() {
        this.id = this.$route.query.review_id;
        this.getFn();
    },
    methods: {
        getActive(answer) {
            if (typeof answer == 'string') {
                return [answer]
            } else if (typeof answer == 'object') {
                return answer
            } else {
                return []
            }
        },
        getFn() {
            this.$http.review_list({
                review_id: this.id
            }).then(res => {
                console.log(res, '----')
                console.log(typeof this.questionList, '----')
                console.log(this.questionList, '----')
                this.questionList = res.data ? JSON.parse(res.data[0].reviewtext) : [];
                if (this.questionList.length > 0) {
                    this.questionList.forEach(item => {
                        item.children.forEach(child => {
                            child.active = this.getActive(child.active)
                        })
                    })
                }
                if (typeof this.questionList == 'string' || typeof this.questionList == 'number') {
                    this.questionList = []
                }
                console.log(this.questionList, '-323232---')
            })
        },
    }
}
</script>

<style lang="less" scoped>
.input-p {
    border-radius: 4px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333;
    text-indent: 10px;
    flex-wrap: wrap;

    span {
        margin-right: 10px;
    }

    p {
        width: 100%;
    }
}

.title {
    font-size: 22px;
    text-align: center;
    margin-bottom: 30px;
}

.contact {
    padding: 30px;
    box-sizing: border-box;
    max-width: 1100px;
    margin: 0 auto;

    .form-title {
        font-size: 18px;
        background-color: #ccc;
        padding: 5px 10px;
    }

    .question-lists {
        display: flex;
        flex-wrap: wrap;
    }

    .question-list {
        width: 50%;
        font-size: 14px;
        padding-bottom: 10px;
        border: 1px solid #999;
        border-bottom: 0;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        padding-top: 10px;
        box-sizing: border-box;
        padding-left: 20px;
    }

    .question-list:nth-last-of-type(1),
    .question-list:nth-last-of-type(2) {
        border-bottom: 1px solid #999;
    }

    .question-list:nth-of-type(2n) {
        border-left: 0;
    }

    .question-title {
        max-width: 300px;
        min-width: 80px;
        font-size: 16px;
    }

}

@media (max-width: 600px) {
    .contact {
        .top {
            height: 200px;

            .title {
                font-size: 30px;
            }
        }

        .con {
            padding: 0 20px;
        }

        .title {
            font-size: 20px;
        }

        .step {
            zoom: 0.7;
        }

        .step1 {
            padding: 10px 20px;
        }

        .step2 {
            font-size: 18px;
            margin: 100px auto 150px;
        }

        .step2+.btn {
            margin: 0 auto 30px;
        }

        .form {
            padding: 0 15px;
            box-sizing: border-box;

            .question-list {
                padding: 10px;
            }

            .form-title {
                font-size: 20px;
            }

            .question-title {
                font-size: 16px;
            }

            .question-list:nth-child(2n) {
                border-left: none;
            }

            .question-list {}
        }

        .text p {
            font-size: 14px;
        }

        .text {
            padding: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/zh/infoDetail.vue